import {useState} from 'react';
import strings from './strings.js'
import useSongSearch from './useSongSearch.js';
import { useNavigate } from 'react-router-dom';
import { SendMessage } from './App.js';
import icoPlay from './img/ico-playOverview.svg';
import icoPlayRed from './img/ico-playOverviewRed.svg';

const API_URL = "https://www.starboxkod.com/api";

const TableCardOverview = ({ skin, tableName, table, lang, jiheonIndex} ) => {
    const navigate = useNavigate()
    
    const [pageNumber, setPageNumber] = useState(0);

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSongSearch(table.playlist.map(f=> f.songcode).toString(), pageNumber)

    const lookup = Object.fromEntries(songs.map(o => [o.song_num, o]));

    lookup["1111"] = {
        "song_num": null,
        "song_name": "YOUTUBE",
        "singer": "YOUTUBE",
        "singer2": null,
        "singer3": null,
        "language": null,
        "server_id": "null",
        "rel_path": "null",
        "audio_track": 1
    };

    // Define the color palette for style == 1
    const styleOneColors = [
        "#ff9899",
        "#ffc699",
        "#fff699",
        "#adff99",
        "#99ffb3",
        "#9affe1",
        "#99f1ff",
        "#fe99d5",
        "#ff99a7"
    ];

    // Determine the background color based on table lock status and style prop
    const getBackgroundColor = () => {
        if (table.locked) return "#d9d9d9";
        if (skin == 1) return styleOneColors[jiheonIndex % styleOneColors.length];
        return "#ffb8d1"; // default for style == 0
    };

    return (
    <>
        <div className="overview-container-table"  style={{backgroundColor: getBackgroundColor()}}>
            <div className="overview-container-table-current">{table.playing ? <img src={document.body.getAttribute('data-skin') === '1' ? icoPlayRed :icoPlay} /> : "" }</div>
            <div className="overview-container-table-name">{lang ? "桌号" : "Table "} {parseInt(tableName.substring(1))}</div>        
            <div className="overview-container-table-quota" onClick={(e) => {e.preventDefault(); console.log(skin)}}>{table.quota}</div>
        </div>

        
        {!loading && table.playlist.map(f=> f.songcode).toString() != ""
        ? (
            <>
                {table.playlist.map(f=> f.songcode).toString().split(',').map((song_num, index) => {
                    if (lookup[song_num] != null) {
                        if (song_num == "1111") {
                            lookup["1111"] = {
                                "song_num": null,
                                "song_name": table.playlist.map(f => f.ytname)/*.toString().split(',')*/[index].substring(0, 20),
                                "singer": "YOUTUBE",
                                "singer2": null,
                                "singer3": null,
                                "language": null,
                                "server_id": "null",
                                "rel_path": "null",
                                "audio_track": 1
                            }
                        }
                        return <div key={index} className="overview-container-selected">{lookup[song_num].song_name} - {lookup[song_num].singer} {lookup[song_num].singer2 && `, ${lookup[song_num].singer2}`} {lookup[song_num].singer3 && `, ${lookup[song_num].singer3}`}</div>
                    }
                })}
            </>
        ) :
        (
            <></>
        )}

    </>
    );
}

export default TableCardOverview;